import { LoadingButton } from "@mui/lab";
import { Box, Grid, TextField, Typography, styled } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../../components/shared/LoadingSpinner";
import { InvoicingOptions } from "../../../models/employers/invoicingOptions";
import { useData } from "../../../utils/useData";
import { useUpdateInvoicingOptions } from "../../../hooks/invoicing/useUpdateInvoicingOptions";

const OptionsTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
  marginBottom: 16
});

const Invoicing = () => {
  const { employer } = useData();
  const [initialFormValues, setInitialFormValues] = useState<InvoicingOptions>({
    reference: ""
  });

  useEffect(() => {
    if (employer.data) {
      setInitialFormValues({
        reference: employer.data.invoicingOptions?.reference || ""
      });
    }
  }, [employer.data]);

  const updateInvoicingOptions = useUpdateInvoicingOptions();

  const formik = useFormik({
    initialValues: initialFormValues,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await updateInvoicingOptions.mutateAsync(values);
        setSubmitting(false);
      } catch (error) {
        console.error("Error saving invoicing preferences:", error);
        setSubmitting(false);
      }
    }
  });

  const employerIsLoading = employer.isIdle || employer.isLoading;

  if (employerIsLoading) return <LoadingSpinner />;

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ p: 3, width: "100%" }}>
        <Grid container item xs={6} spacing={2}>
          <Grid item xs={12}>
            <OptionsTitle>Reference for Invoices</OptionsTitle>
            <TextField
              name="reference"
              value={formik.values.reference}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 50 && /^[a-zA-Z0-9-]*$/.test(value)) {
                  formik.setFieldValue("reference", value);
                }
              }}
              color="primary"
              size="small"
              placeholder="eg. Purchase order number"
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              loading={formik.isSubmitting}
              disabled={!formik.dirty}
              fullWidth
              sx={{ mt: 2 }}
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export { Invoicing };
